import classNames from 'classnames'
import {useSelector} from 'react-redux'

function LargeSwitch({onChange, checked, name, disabled}) {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    return (
        <label className={classNames('large-switch', {
            dark: isDarkMode
        })}>
            <input type="checkbox" id={name} name={name} onChange={onChange}
                checked={checked} disabled={disabled}/>
            <span className={classNames({
                'switch-slider round': true,
                'off': !checked
            })}/>
        </label>
    )
}

export default LargeSwitch
